export default {
    view: "Visualizza di più"
}